"use client";

import { createContext, useContext } from "react";

import type { MenuItem } from "@/components/types";

/**
 * Interface for the Menu Context.
 */
export interface MenuContextType {
  /** Menu items fetched from the `menu` endpoint. */
  data: MenuItem[];
  /** Whether the menu request is in flight. */
  sidebarIsOpen: boolean;
  setSidebarIsOpen: (isOpen: boolean) => void;
  /** Re-fetches the menu from the backend. */
  refetch: () => void;
}

export const MenuContext = createContext<MenuContextType | undefined>(
  undefined
);

/**
 * Custom hook to consume the MenuContext.
 *
 * @returns {MenuContextType} The context value.
 * @throws {Error} If used outside of a AsideMenu.
 */
export const useMenu = (): MenuContextType => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error("useMenu must be used within a AsideMenu");
  }
  return context;
};
